import TableView from "@/common/components/TableViewNew/TableView";
import { Grid } from "@mui/material";
import React from "react";
import { columns, rejectedSchemeColumns, reportFileName } from "./constants/constants";
import useOnActions from "./hooks/useOnActions";
import AlertDialog from "@/common/components/alert-dialog/alert-dialog";
import { requestedMenuAll, requestedFeaturesAll } from "@/from-theme/routes/constants/menuAccess";
import { isUserHasAccess } from "@/from-theme/utils/route-guard/helpers/helpers";
import useAuth from "@/from-theme/hooks/useAuth";
import useSchemeStatusMaster from "./hooks/useSchemeStatusMaster";
import RejectedCustomerEditModal from "./components/RejectedCustomerEditModal";
import RejectedCustomersDetailModal from "./components/RejectedCustomersDetailModal";
const { schemeStatusMasterKey } = requestedMenuAll;
const { updateKey, deleteKey } = requestedFeaturesAll;

const SchemeStatusMaster = () => {

  const {
    schemesMasterData, schemesMasterStatus, schemesMasterErrMsg,
    rejectedCustomersData, rejectedCustomersStatus, rejectedCustomersErrMsg
  } = useSchemeStatusMaster();


  const { userData } = useAuth();
  const entitlement = userData?.entitlement || {};

  const isUpdateDeleteAccess = isUserHasAccess(schemeStatusMasterKey, updateKey, entitlement)
    || isUserHasAccess(schemeStatusMasterKey, deleteKey, entitlement);

  const {
    onRowEdit,
    onRowDelete,
    deleteCompetitorMasterStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,
    onRowEditCustomer,
    selectedRejectedCustomer,
    isRejectedModalOpen,
    setIsRejectedModalOpen,
    onViewDetailed,
    selectedRejectedScheme,
    isDetailModalOpen,
    setIsDetailModalOpen,
    detailsRefreshTrigger,
    onRefreshDetails
  } = useOnActions();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TableView
          data={schemesMasterData}
          columns={columns({
            onRowEdit, onRowDelete, deleteCompetitorMasterStatus,
            isUpdateDeleteAccess
          })}
          reportFileName={reportFileName}
          apiStatus={schemesMasterStatus}
          apiErrorMsg={schemesMasterErrMsg}
          stringInExport={["activeStatus"]}
        />
        <Grid item xs={12} sx={{ mt: 5 }}>
          <TableView
            data={rejectedCustomersData}
            columns={rejectedSchemeColumns({ onViewDetailed, isUpdateDeleteAccess })}
            reportFileName="Rejected Schemes List"
            apiStatus={rejectedCustomersStatus}
            apiErrorMsg={rejectedCustomersErrMsg}
          />
        </Grid>
        {isAlertDialog && (
          <AlertDialog onCloseAlert={onCloseAlert} onAgreeAlert={onAgreeAlert} />
        )}
        <RejectedCustomersDetailModal
          open={isDetailModalOpen}
          onClose={() => setIsDetailModalOpen(false)}
          schemeData={selectedRejectedScheme}
          onEditCustomer={onRowEditCustomer}
          isUpdateDeleteAccess={isUpdateDeleteAccess}
          refreshTrigger={detailsRefreshTrigger}
        />
        <RejectedCustomerEditModal
          open={isRejectedModalOpen}
          onClose={() => setIsRejectedModalOpen(false)}
          customerData={selectedRejectedCustomer}
          onSuccess={onRefreshDetails}
        />
      </Grid>
    </Grid>
  );
};

export default SchemeStatusMaster;